import { useTranslation } from 'react-i18next';

import { SegmentedTabs } from '~/components/common/segmented-tabs';

import type { CompareViewMode } from './compare-grid.types';

interface CompareViewToggleProps {
  mode: CompareViewMode;
  onModeChange: (mode: CompareViewMode) => void;
  /** Automation hook: tablist id; each tab gets `${testId}-table` / `${testId}-compare`. */
  testId?: string;
}

/** Table/Compare switch shown in the preview section header — picks which product-listing presentation the page renders. */
export function CompareViewToggle({
  mode,
  onModeChange,
  testId = 'compare-view-toggle',
}: CompareViewToggleProps) {
  const { t } = useTranslation('content-enrichment');

  return (
    <SegmentedTabs<CompareViewMode>
      value={mode}
      onChange={onModeChange}
      ariaLabel={t('compareGrid.viewMode.ariaLabel')}
      options={[
        { value: 'table', label: t('compareGrid.viewMode.table') },
        { value: 'compare', label: t('compareGrid.viewMode.compare') },
      ]}
      className="bg-background border"
      testId={testId}
    />
  );
}
